var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boat__info"},[_c('h1',[_vm._v("404 Not Found")]),_vm._v(" "),_c('p',[_vm._v("We're sorry, but the page you're looking for couldn't be found. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to inventory?")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }